import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { DriverDescription } from '../models/DriverDescription.model';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ManagerDriversService {
  private state = new BehaviorSubject<Map<string, DriverDescription>>(
    new Map()
  );
  private state$ = this.state.asObservable();

  // ESTE DEBERIA SER UN AUXILIAR PARA QUE SE CARGUE PERO POR UN MOTIVO DEVULEVE NULL
  /* 
  constructor(vehicleService: VehicleService) {
    vehicleService
      .getVehicles()
      .pipe(
        tap((units: any[]) => {
          const initialState = new Map<string, DriverDescription>();
          units.forEach((unit) => {
            if (!unit.IMEI) return;
            initialState.set(unit.IMEI.toString(), {
              id: unit.driver_id,
              long_name: unit.namedriver,
              short_name: '',
            });
          });
          this.state.next(initialState);
        })
      )
      .subscribe();
  } */

  loadData(units: any[]) {
    if (units && units.length > 0) {
      const initialState = new Map<string, DriverDescription>();
      units.forEach((unit) => {
        if (!unit.IMEI) return;

        const nameDriver = unit.namedriver;

        initialState.set(unit.IMEI.toString(), {
          id: unit.driver_id,
          long_name: !nameDriver ? 'Conductor desconocido' : nameDriver,
          short_name: '',
        });
      });
      this.state.next(initialState);
    }
  }

  get getDescriptionsDriver() {
    return this.state$.pipe(map((state) => Array.from(state.values())));
  }

  getDescriptionDriverByImei(imei: string): DriverDescription | undefined {
    const driver = this.state.value.get(imei);
    return driver;
  }
}
